'use strict';

module.exports = emphasis;

var all = require('../all');

function emphasis(h, node) {
  return h(node, 'emphasis', all(h, node));
}
